
import { IChartDataPerMonthPerYear } from "@/utils/chart-income";
import Vue from "vue";
import AppIncomeChart from "./IncomeChart.vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import {ChartService} from "@/services";
import { DashboardChartData } from "@/utils/dashboard/dashboard-chart-data";

export default Vue.extend({
	data(){
		return {
			income: null as null | IChartDataPerMonthPerYear
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		data():DashboardChartData{
			return this.item.Data as DashboardChartData;
		}
	},
	methods: {
		async fetch(){
			this.income = await ChartService.getIncome(1, this.data.filters, this.data.getBookYearOverrideValue());
		}
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppIncomeChart
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
